import { post } from 'aws-amplify/api';
import { fetchAuthSession } from '@aws-amplify/auth';

// Unified helper to call the unified /api endpoint with the reports operation
const callReportsApi = async (payload) => {
  try {
    // Attach Cognito access token (optional; API authorizer may validate request)
    const session = await fetchAuthSession();
    const accessToken = session?.tokens?.accessToken?.toString?.() || session?.tokens?.accessToken;

    const operation = post({
      apiName: 'DailyReportAPI',
      path: '/api',
      options: {
        body: {
          operation: 'fetchData',
          ...payload
        },
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined
      }
    });

    const response = await operation.response;
    const data = await response.body.json();
    return data;
  } catch (error) {
    console.error('Request failed:', error);
    throw error;
  }
};

export const postRequest = async (payload) => callReportsApi(payload);
export const getRequest = async (payload) => callReportsApi(payload);
export const putRequest = async (payload) => callReportsApi(payload);
